module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - moojiwa.741382e6.pdf";